import Button from "../ui/Button";
import { PlayerType } from "./Players";
import userDefaultImage from "../../assets/images/user.webp";
import Text from "../../../../components/ui/Text";
import deleteImage from "../../assets/images/delete.webp";
import pencilImage from "../../assets/images/pencil.webp";
import { truncString } from "../../helpers";

interface Props {
  className?: string;
  player: PlayerType;
  onDeleteClick: (player: PlayerType) => void;
  onEditClick: (player: PlayerType) => void;
  onPlayerClick?: (player: PlayerType) => void;
}

const Player = ({
  className = "",
  player,
  onDeleteClick,
  onEditClick,
  onPlayerClick,
}: Props) => {
  return (
    <Button
      disableHoverTranslate
      variant="light-gray"
      onClick={() => {
        if (onPlayerClick) {
          onPlayerClick(player);
        }
      }}
      className={`relative ${className}`}
    >
      <div className="flex items-center justify-between">
        {/** Profile Picture & Info */}
        <div className="flex items-start space-x-2">
          {/** Image */}
          <div
            className="p-[1px] rounded-sm"
            style={{
              background: "linear-gradient(to bottom, #525B61 0%, #272832 70%)",
            }}
          >
            <div
              style={{
                background: "radial-gradient(circle, #525B61 0%, #22242c 100%)",
              }}
              className="p-[2px] rounded-sm  w-[29px] h-[29px] flex items-center justify-center"
            >
              <img
                src={player.profilePicture || userDefaultImage}
                alt="User"
                className="w-[13px] h-[13px] object-contain"
              />
            </div>
          </div>

          {/** Name & Role */}
          <div className="text-left">
            <Text size="xxs" className="text-white/70 leading-[100%]">
              {truncString(player.name)}
            </Text>
            <Text className="text-[#E8FF56]" size="xxxs">
              {player.role}
            </Text>
          </div>
        </div>

        {/** Actions */}
        <div className="flex items-center space-x-1">
          <Button
            disableHoverTranslate
            variant="gray"
            className="hover:!bg-blue-500"
            onClick={() => {
              onEditClick(player);
            }}
            innerStyle={{
              background: "radial-gradient(circle, #45464d 0%, #37393f 100%)",
            }}
          >
            <img
              src={pencilImage}
              alt="Edit"
              className="w-[10px] h-[10px] object-contain"
            />
          </Button>
          <Button
            disableHoverTranslate
            variant="gray"
            className="hover:!bg-red-500"
            onClick={() => {
              onDeleteClick(player);
            }}
            innerStyle={{
              background: "radial-gradient(circle, #45464d 0%, #37393f 100%)",
            }}
          >
            <img
              src={deleteImage}
              alt="Delete"
              className="w-[10px] h-[10px] object-contain"
            />
          </Button>
        </div>
      </div>
    </Button>
  );
};

export default Player;
